export const CODE_COMMUNE_FILE_NAME = "/assets/filtered-code-commune.json";
let communeCodes: Record<string, string>;

/**
 * Mostly for tests to avoid fetching the file
 */
export function setCommuneCodes(codes: Record<string, string>): void {
  communeCodes = codes;
}

export default async function searchBirthPlace(
  communalCode: string
): Promise<string> {
  if (!communeCodes) {
    try {
      const res = await fetch(CODE_COMMUNE_FILE_NAME);
      communeCodes = await res.json();
    } catch (e) {
      console.error(
        `Failed to load '${CODE_COMMUNE_FILE_NAME}' : ${e.message}`
      );
    }
  }

  return communeCodes?.[communalCode];
}
